export default {
  userSubscriptionDetails: (state: any) => {
    return state.userSubscriptionDetails;
  },
};
